import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';
import Upload from '@/views/components/upload/upload.vue';

@Component({
  components: { Upload },
  mixins: [style],
})
export default class HotBg extends Vue {
  @Prop({ default: () => {} })
    value: DisplayHotBgData;

  @Prop()
    disabled: boolean;

  data: DisplayHotBgData = {};

  // 历史值
  history = '';

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  onChange(val) {
    if (val === 2) {
      this.data.desc.backPic = '';
    }
  }

  uploadImgSuccess(res) {
    this.data.desc.backPic = res.content;
  }

  render(h) {
    return (
      <div class="hotBg-edit">
        <el-form props={{ model: this.data }} ref="form" disabled={this.disabled}>
          <el-form-item>
            <el-radio-group v-model={this.data.desc.showBackPic} class="radio-group" onChange={this.onChange.bind(this)}>
              <el-radio label={1}>使用背景图</el-radio>
              <el-radio label={2}>不使用背景图</el-radio>
            </el-radio-group>
          </el-form-item>
          {this.data.desc.showBackPic === 1 && [
            <el-form-item prop="desc.backPic" rules={{ required: true, message: '请选择背景图片', trigger: ['blur', 'change'] }}>
              <Upload onImgUploadSuccess={this.uploadImgSuccess} img={this.data.desc.backPic} noDelete={false} maxSize={1024} />
            </el-form-item>,
            <p class="tip blockTip">注1： 此背景图将出现在HOT页及活动页；</p>,
            <p class="tip blockTip">注2： 建议图片大小为 750px*600px，不超过1M；</p>,
            <p class="tip blockTip">注3： 支持jpg/jpeg、png、gif格式图片，如图片为异形图，请确保图片格式为png。</p>,
          ]}
        </el-form>
      </div>
    );
  }
}
